import { Box, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import DownloadWaitIcon from "@assets/download_wait_icon.svg";
import DownloadWarningIcon from "@assets/download_warning_icon.svg";

interface DetalleAbortivoProps {
    props: any;
}

export const DetalleAbortivo = (props: DetalleAbortivoProps) => {
    return (
        <Box m={2}>
            <Table>
                <TableBody>
                    {Object.keys(props.props)
                        .filter((k) => ["show_menu", "label"].some((lbl) => lbl === k) === false)
                        .map((k: any, idx) => {
                            return (
                                <TableRow key={idx}>
                                    <TableCell
                                        padding="normal"
                                        sx={{ borderBottom: "1px solid #A3D4E8", paddingRight: 5 }}
                                    >
                                        <Typography variant="body3" fontWeight={500} color="main3">
                                            {props.props[k].label}
                                        </Typography>
                                    </TableCell>
                                    <TableCell padding="none" sx={{ borderBottom: "1px solid #A3D4E8" }} align="right">
                                        {props.props[k].value === true && (
                                            <img
                                                src={DownloadWarningIcon}
                                                style={{ width: 18, height: 18, marginLeft: 2 }}
                                            />
                                        )}
                                        {props.props[k].value === false && <CheckIcon sx={{ color: "#528CD6" }} />}
                                        {props.props[k].value === null && (
                                            <img
                                                src={DownloadWaitIcon}
                                                style={{ width: 18, height: 18, marginLeft: 2 }}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell
                                        padding="normal"
                                        sx={{ borderBottom: "1px solid #A3D4E8" }}
                                        align="right"
                                    >
                                        <Typography
                                            variant="body3"
                                            color={
                                                props.props[k].value === true
                                                    ? "main4"
                                                    : props.props[k].value === null
                                                      ? "secondary4"
                                                      : "main2"
                                            }
                                            fontWeight={500}
                                        >
                                            {props.props[k].value === true
                                                ? "No Cumple"
                                                : props.props[k].value === null
                                                  ? "Procesando"
                                                  : "Cumple"}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                </TableBody>
            </Table>
        </Box>
    );
};
